import { render, staticRenderFns } from "./MemoComment.vue?vue&type=template&id=6ff25b24&scoped=true&"
import script from "./MemoComment.vue?vue&type=script&lang=js&"
export * from "./MemoComment.vue?vue&type=script&lang=js&"
import style0 from "./MemoComment.vue?vue&type=style&index=0&id=6ff25b24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff25b24",
  null
  
)

export default component.exports